import { useFiltersState } from '@common/hooks';
import { StateSetter } from '@common/services';
import { ResetFiltersButton } from '@common/ui';
import { ActiveFiltersText, SearchTextFilter } from '@common/ui/filters';
import React from 'react';
import { NiveauCertificationFilter } from './NiveauCertificationFilter';
import { TypeCertificationFilter } from './TypeCertificationFilter';

export const CommonRncpFilters = ({ filters, setFilters, filtersTexts, defaultFilters }: RncpFiltersProps) => {
  const { hasSomeFilters, activeFiltersTexts } = useFiltersState({ filters, texts: filtersTexts });
  return (
    <React.Fragment>
      <div className={'flex items-center gap-6'}>

        <SearchTextFilter search={filters.search}
                          onSearchChange={(search) => setFilters((prevFilters) => ({ ...prevFilters, search }))}
                          minLength={3}
                          debounceTime={500}
                          emitIfEmpty />

        <TypeCertificationFilter type={filters.typeCertification}
                                 onTypeChange={(typeCertification) => setFilters((prevFilters) => ({
                                   ...prevFilters, typeCertification,
                                 }))} />

        <NiveauCertificationFilter niveau={filters.niveauCertification}
                                   onNiveauChange={(niveauCertification) => setFilters((prevFilters) => ({
                                     ...prevFilters, niveauCertification,
                                   }))} />

        {(hasSomeFilters) && (
          <ResetFiltersButton onClick={() => setFilters(defaultFilters)} />
        )}
      </div>

      {(hasSomeFilters) && (
        <ActiveFiltersText texts={activeFiltersTexts} />
      )}
    </React.Fragment>
  );
};

interface RncpFiltersProps {
  filters: RncpFilters;
  setFilters: StateSetter<RncpFilters>;
  filtersTexts: Record<keyof RncpFilters, string>;
  defaultFilters: RncpFilters;
}

export interface RncpFilters {
  search: string;
  typeCertification: string | null;
  niveauCertification: string | null;
}